import React from 'react';
import _ from 'lodash';
import slugify from 'slugify';
import { Link, withPrefix } from 'gatsby';

import { TableData, TableRow } from '~components/common/Table';
import { rowRendererProps } from '../propTypes';
import { RowDataRenderer } from './default';

export default function VoterRegistrationMethodsRowRenderer({ state }) {
  const stateName = state.fieldValue;
  const stateSlug = slugify(stateName.toLowerCase());
  const stateData = _.keyBy(state.nodes, 'field_type');

  const registrationMethods = stateData.registration_methods
    ? stateData.registration_methods.multiselect_value
    : [];

  return (
    <TableRow>
      <TableData>
        <a
          href={`/how-to-vote/${stateSlug}/`}
          title={`How to vote in ${stateName}`}
        >
          {stateName}
        </a>
      </TableData>
      <RowDataRenderer
        columns={[
          {
            title: 'Mail',
            valueBool: registrationMethods.includes('mail'),
          },
          {
            title: 'In person',
            valueBool: registrationMethods.includes('in_person'),
          },
          {
            title: 'Fax',
            valueBool: registrationMethods.includes('fax'),
          },
          {
            title: 'Email',
            valueBool: registrationMethods.includes('email'),
          },
          {
            title: 'Online',
            valueBool: registrationMethods.includes('online'),
          },
          {
            title: 'Register to vote',
            valueNode: (
              <Link
                to={withPrefix(
                  `/register-to-vote/${slugify(stateName.toLowerCase())}/`
                )}
                title={`Register to vote in ${stateName}`}
              >
                Register to vote in {stateName}
              </Link>
            ),
          },
        ]}
      />
    </TableRow>
  );
}

VoterRegistrationMethodsRowRenderer.propTypes = rowRendererProps;
